import { gql } from 'apollo-angular';

// TODO: ottimizzare inserendo solo la parte relativa alla licenza (l'utente non viene utilizzato)
// accountLicenseQuery...
export const accountQuery = gql`
  query Account {
    account {
      id
      assignedTo
      type
      expirationDate
      owner
      currentStatus
      freeTrialActivationDate
      commissioningActivationDate
    }
  }
`;

export const getAccountUserQuery = gql`
  query GetAccountUser {
    getUserAccount {
      id
      name
      lastName
      email
      phone
      company
    }
  }
`;

export const transferLicenseMutation = gql`
  mutation TransferUserAccountLicense(
    $fromUserId: ID!
    $toUserId: ID!
    $licenseId: ID!
  ) {
    transferUserAccountLicense(
      fromUserId: $fromUserId
      toUserId: $toUserId
      licenseId: $licenseId
    ) {
      id
      name
      lastName
      license {
        id
        assignedTo
        type
        expirationDate
        owner
      }
    }
  }
`;

export const getUserAvatarQuery = gql`
  query GetUserAvatar {
    getUserAvatar
  }
`;

export const updateUserAvatarMutation = gql`
  mutation UpdateUserAvatar($id: ID!, $imgUrl: String!) {
    updateUserAvatar(id: $id, imgUrl: $imgUrl)
  }
`;

export const getLicenseIdQuery = gql`
  query GetLicenseId {
    getLicenseId
  }
`;

export const updateAccountUserMutation = gql`
  mutation UpdateAccountUser(
    $id: ID!
    $name: String!
    $lastName: String!
    $email: String!
    $phone: String!
    $company: String!
  ) {
    updateAccountUser(
      id: $id
      name: $name
      lastName: $lastName
      email: $email
      phone: $phone
      company: $company
    )
  }
`;
